// extracted by mini-css-extract-plugin
export default {"tariffPolicy":"AppSidebarFuel_tariffPolicy_jeJ2b"};